import ServiceCategoryPage from "../components/ServiceCategoryPage";
import modularKitchenInstallerService from "../data/services/modularKitchenInstallerService";

function ModularKitchenInstaller() {
  return <ServiceCategoryPage service={modularKitchenInstallerService} />;
}

export default ModularKitchenInstaller;